import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AdminAuthContextProvider } from './administrator/admin/AdminAuthContext';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>

     <AdminAuthContextProvider>
            <App />
     </AdminAuthContextProvider>
  </React.StrictMode>
);

